import Button from "@/components/Button"
import {
  BB,
  BK,
  BN,
  BP,
  BQ,
  BR,
  WB,
  WK,
  WN,
  WP,
  WQ,
  WR,
} from "@/components/pieces"
import { ActiveMove, ExtendedMove } from "@/types/types"
import clsx from "clsx"
import MovesList from "./MovesList"
import { useScrollContext } from "../ScrollProvider"

type Props = {
  move: ExtendedMove
  active: boolean
  position?: ActiveMove
  widthClassName?: string
  disabled?: boolean
  onClick: (...args: any[]) => any
  hidden?: boolean
}

const iconsMap = {
  wb: WB,
  wk: WK,
  wn: WN,
  wp: WP,
  wq: WQ,
  wr: WR,
  bb: BB,
  bk: BK,
  bn: BN,
  bp: BP,
  bq: BQ,
  br: BR,
}

const Move = ({
  move,
  active,
  position,
  widthClassName,
  disabled,
  onClick,
  hidden = false,
}: Props) => {
  const { activeMoveRef } = useScrollContext()
  const { color, piece, annotation, comment, moves, san } = move
  const Icon = iconsMap[`${color}${piece}`]
  const hasMoves = moves && moves?.length > 0
  const isDisabled = disabled || hidden

  return (
    <>
      <Button
        ref={active ? activeMoveRef : null}
        onClick={() => onClick(position)}
        size="sm"
        style="secondary"
        staticWidthClassName={widthClassName}
        disabled={isDisabled}
        className={clsx("relative overflow-hidden", {
          "ring-2 ring-gray-800": active,
        })}
      >
        <Icon
          className={clsx("h-6 w-6 shrink-0", {
            "blur-sm": hidden,
          })}
        />
        <span
          className={clsx("leading-none font-medium text-gray-500", {
            "blur-sm": hidden,
          })}
        >
          {san.replace(piece.toUpperCase(), "")}
          <span className="text-chessdrop-500">{annotation}</span>
        </span>
        {(hasMoves || comment) && (
          <div
            className="border-t-chessdrop-500 absolute -top-2.5 -left-2.5 z-10 h-0 w-0 rotate-135 border-10 border-r-transparent border-b-transparent border-l-transparent"
            aria-hidden="true"
          />
        )}
      </Button>

      {active && moves && (
        <MovesList depth={position?.length ?? 0} moves={moves} />
      )}
    </>
  )
}

export default Move
